import { render, staticRenderFns } from "./ButtonRent.vue?vue&type=template&id=a016c922"
import script from "./ButtonRent.vue?vue&type=script&lang=ts"
export * from "./ButtonRent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports